import React, { useCallback, useEffect, useState } from "react";
import { Text, View, Image } from "react-native";

import { debounce } from "lodash";
import { store } from "../../store/store";
import { View as AnimatableView } from "react-native-animatable"

import { getImagePath } from '../../utils/services/CommonUtils';
import { getCartItemFroRedux, mergeDealListWithCartData, upsertCartItem } from '../../utils/services/oms/OMSCartUtils';
import { getDealDataForCart, getDealPicturesList, getDealSavingPercent } from "../../utils/services/inventory/DealsUtils";

import { PrimaryCTA } from "../../utils/widgets/CommonCTA";
import { UpsertCartItemView } from "../../utils/widgets/UpsertCartItemView";
import { CommonCartHeader } from '../../utils/widgets/CommonWidget/CommonHeader';
import { DealCarouselView, DealsCarouselPagination } from "../../utils/widgets/deals/DealCarouselView";

import { IndiaRupee } from "../../utils/constants/AppConstants";
import { ScreenRoute } from '../../utils/constants/ScreenRouteConstant';

import AppTheme from "../../AppTheme";
import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";

import CustomCarousel from "../../utils/widgets/Carousel/CustomCarousel";

const SelectedDealView = (props) => {

    const [cartItems, setCartItems] = useState([])
    const [deal, setDeal] = useState(props?.route?.params?.deal)
    const [dealPictures, setDealPicture] = useState([])

    const updateCartAndPrecriptionData = () => {
        let cartItems = getCartItemFroRedux()
        let dealData = mergeDealListWithCartData({ deals: [deal], cartItemsList: cartItems })
        if (dealData.isDealListUpdated)
            setDeal(dealData.dealsList[0])
        setCartItems(cartItems)
    }


    const cartAndPrecriptionSubscription = useCallback(
        debounce(() => updateCartAndPrecriptionData(), AppTheme.debouceTimeout), [])

    useEffect(() => {
        configureDealData(deal)
        cartAndPrecriptionSubscription();
        store.subscribe(() => { cartAndPrecriptionSubscription() })
    }, [])

    const cartNavigation = () => {
        props?.navigation?.navigate(ScreenRoute.cart)
    }

    const updateCartDealItem = (isAdd, item, quantity = 1) => {
        upsertCartItem(isAdd, item, quantity, {})
    }

    const configureDealData = (dealData) => {
        var dealPictuesList = getDealPicturesList(dealData)
        if (dealPictuesList.length) setDealPicture(dealPictuesList)
    }

    return (
        <View>

            <CommonCartHeader title={'Product Details'} cartNavigation={cartNavigation}
                navigation={props.navigation} />

            <View style={[AppStyles.screenViewWithHeader, { paddingBottom: 24 }]}>

                <AnimatableView animation="fadeIn"
                    style={[AppStyles.m16]}
                    duration={AppTheme.transitionDuration}>
                    {dealPictures.length ?
                        <CustomCarousel carouselData={dealPictures}
                            carouselViewBuilder={DealCarouselView}
                            paginationViewBuilder={DealsCarouselPagination}
                            viewWidth={AppTheme.appWidth - 32}
                            viewHeight={AppTheme.appWidth - 32}
                            carouelWidth={AppTheme.appWidth - 32}
                            scallingFactorOffset={AppTheme.appWidth - 32} /> :
                        <Image style={{ width: AppTheme.appWidth - 32, height: AppTheme.appWidth - 32 }}
                            source={{ uri: getImagePath('/images/deals/noDealImage.png') }} />}
                </AnimatableView>

                <Text style={[TextStyle.text16b, TextStyle.flexWrap, AppStyles.px16, , TextStyle.alignLeft,
                { marginTop: 32 }]}>{deal.n}</Text>

                {deal.psl ? <Text style={[TextStyle.text12, TextStyle.flexWrap, AppStyles.px16, TextStyle.alignLeft, {
                    marginTop: 6, color: AppTheme.color.grey.text
                }]}>{deal.psl}</Text> : null}

                <View style={[AppStyles.py16, AppStyles.px16, AppStyles.flexRowSpaceBetween]}>

                    <View style={[AppStyles.flexRowStart]}>
                        <Text style={[TextStyle.text14b]}>
                            {IndiaRupee}{deal['rp']}</Text>
                        {deal['rp'] && deal['rp'] != deal['mrp'] && <Text
                            style={[TextStyle.text12, TextStyle.lineThrough, TextStyle.alignCenter,
                            { marginLeft: 4, color: AppTheme.color.grey.fillerInfo }]}>
                            {IndiaRupee} {deal['mrp']}</Text>}
                        {getDealSavingPercent(deal) && <Text style={[TextStyle.text12b,
                        { marginLeft: 4, color: AppTheme.color.green.primary }]}>
                            {getDealSavingPercent(deal)}</Text>}
                    </View>

                    {deal.quantity ? <UpsertCartItemView updateCartItem={updateCartDealItem}
                        key={'deal_quan_' + deal.dealId} viewStyle={{ paddingVertical: 3 }}
                        item={getDealDataForCart(deal)} /> :
                        <PrimaryCTA action={() => updateCartDealItem(true, getDealDataForCart(deal))}
                            title={'Add To Cart'} width={115} paddingVertical={6}
                            key={'deal_cta_' + deal.dealId} />}
                </View>

                {deal['dsc'] && <View style={[AppStyles.pt16, AppStyles.px16, AppStyles.bg, { paddingBottom: 24 }]}>
                    <Text style={[TextStyle.text14, AppStyles.mt12]}>
                        Description</Text>
                    <Text style={[TextStyle.text12, TextStyle.flexWrap, AppStyles.mt8]}>
                        {deal['dsc']}</Text>
                </View>}

            </View>
        </View>
    )
}

export default SelectedDealView
